import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const SquareDots = createIcon({
  displayName: 'SquareDots',
  viewBox: '0 0 24 24',
  path: [
    <circle cx="2" cy="2" key="p1" r="2" />,
    <circle cx="2" cy="12" key="p2" r="2" />,
    <circle cx="2" cy="22" key="p3" r="2" />,
    <circle cx="12" cy="2" key="p4" r="2" />,
    <circle cx="12" cy="12" key="p5" r="2" />,
    <circle cx="12" cy="22" key="p6" r="2" />,
    <circle cx="22" cy="2" key="p7" r="2" />,
    <circle cx="22" cy="12" key="p8" r="2" />,
    <circle cx="22" cy="22" key="p9" r="2" />,
  ],
})
